import logger from '@goldcast/logger';

if (process.env.NODE_ENV === 'development' && !(window as any).configs) {
  const { default: devConfig } = await import('@/devConfig');
  (window as any).configs = devConfig;
}

function getEnv(name: string): any {
  const result = window?.configs?.[name];
  if (!result) {
    logger.error('[AdminApp] Missing environment configuration', { configKey: name });
    return '';
  }
  return result;
}

export { getEnv };
